module.exports = __webpack_public_path__ + "static/media/initiate_change.e9a8478b.png";